"use client";
import { jsxs as a, jsx as n } from "react/jsx-runtime";
import { useEffect as m } from "react";
import { ModalDialog as o } from "@zapier/design-system-beta";
import { Spinner as c } from "@zapier/design-system";
import { emitUserInteractionEvent as v } from "../../observability/tracking/emitEvent.es.js";
import { UserInteractionEventName as f } from "../../observability/tracking/trackingTypes.es.js";
const u = "_footer_1lz1p_1", g = {
  footer: u
};
var j = function(l) {
  var i = l.products, r = l.slug;
  m(function() {
    v(f.templateLoadingScreenViewed, {
      event_action: "in_view",
      option_selected: r
    });
  }, [r]);
  var d = (i ?? []).map(function(e, p, s) {
    var t;
    return e?.slug === ((t = s.at(-1)) === null || t === void 0 ? void 0 : t.slug) && s.length > 1 ? "and ".concat(e?.nameSingular) : e?.nameSingular;
  }).join(", ");
  return /* @__PURE__ */ a(o.Root, { isOpen: !0, isDismissable: !1, children: [
    /* @__PURE__ */ n(o.Header, { textAlign: "center", children: "Building your workflow..." }),
    /* @__PURE__ */ n(o.Body, { textAlign: "center", children: /* @__PURE__ */ a("p", { children: [
      "Hold tight! Your shiny new ",
      d,
      " will be ready soon."
    ] }) }),
    /* @__PURE__ */ n(o.Footer, { children: /* @__PURE__ */ n("div", { className: g.footer, children: /* @__PURE__ */ n(c, {}) }) })
  ] });
};
export {
  j as TemplateCreationModal
};
//# sourceMappingURL=TemplateCreationModal.es.js.map
